module.exports = __webpack_public_path__ + "static/media/information-icon.8bc1dbd8.svg";